module.exports = __webpack_public_path__ + "static/media/03C.264364c7.png";